const availableTrialsAdapter = availableTrials => {
  return availableTrials.map(trial => {
    const firstTrialParcel = trial.parcels.length > 0 ? trial.parcels[0] : null;
    return {
      name: trial.name,
      trialId: trial.id,
      apiName: firstTrialParcel && firstTrialParcel.productApiName || null
    };
  });
};
export default availableTrialsAdapter;